import React from 'react';

import { Box, Text } from '@/components';
import { useTranslation } from '@/hooks';

export type ProductCountProps = {
  count: number;
};

const ProductCount: React.FC<ProductCountProps> = ({ count }) => {
  const { t } = useTranslation('components.productCount');
  return (
    <Box display="flex" justifyContent="center" my={{ base: 5, md: 8 }}>
      <Text fontWeight={700} fontSize={{ base: 'sm', md: 'lg' }}>
        {count} {t('product')}
      </Text>
    </Box>
  );
};

export default ProductCount;
